import React, { Component } from 'react';
import Layout from 'antd/es/layout';
import Breadcrumb from 'antd/es/breadcrumb';
import 'antd/es/layout/style';
import 'antd/es/breadcrumb/style';

import { UIHeader, validate, AppModel, CommonTree } from 'galaxy-framework';

import DataSearchService from './service';

import { RouteComponentProps } from 'react-router';
import Cookies from 'js-cookie';

const { Content, Footer } = Layout;

interface iProps extends RouteComponentProps {
    children: React.ReactNode;
    appName: string;
    appModel?: AppModel;
    HideHeader?: boolean;
}

interface iState {
    app: AppModel;
    zoneList: CommonTree[];
    breadcrumbItem: string[];
}

export default class App extends Component<iProps, iState> {
    private dataSearchService: DataSearchService = new DataSearchService();
    state: iState = {
        app: new AppModel(),
        zoneList: [],
        breadcrumbItem: [],
    };

    async componentWillMount() {
        await this.validate();
        await this.getAppInfo();

        // if (this.props.location.pathname === "/") {
        //   this.props.history.replace({
        //     pathname: this.state.app.functionItems[0].url,
        //   });
        // }
    }

    async validate() {
        let { data } = await validate(Cookies.get('token'));
        if (data == 'ok') {
            (document.querySelector('#root') as HTMLDivElement).style.display = 'block';
            (document.querySelector('#splash') as HTMLDivElement).style.display = 'none';
        } else {
            window.location.replace(`/fe-pc/fe_newlogin/login?fromUrl=${window.location.href}`);
        }
    }

    async getAppInfo() {
        let { appName, appModel = null } = this.props;
        let app: AppModel;
        if (!appModel) app = await this.dataSearchService.getAppInfo();
        else app = appModel;
        let breadcrumbItem = [app.menuItems.find((menuItem) => menuItem.appName === appName).name];
        this.setState({ app, breadcrumbItem });
    }

    render() {
        let { children, appName } = this.props;
        let { app, breadcrumbItem } = this.state;
        return (
            <Layout style={{ minHeight: '100vh', minWidth: 'fit-content', backgroundColor: '#fff' }}>
                {!this.props.HideHeader && (
                    <UIHeader
                        menuItems={app.menuItems}
                        avatar={app.user.avatar}
                        userName={app.user.username}
                        fullName={app.user.fullName}
                        name={app.tenant.appName}
                        schoolName={app.tenant.name}
                        appName={appName}
                        logo={app.tenant.logo}
                        hasSearchBar={app.hasSearchBar}
                    />
                )}
                <Layout style={{ marginTop: !this.props.HideHeader ? 48 : 0 }}>
                    <Layout
                        style={{
                            marginLeft: 0,
                            backgroundColor: '#fff',
                        }}
                        className="main"
                    >
                        <div className="homeImage"></div>
                        {this.props.location.pathname !== '/index' && (
                            <Breadcrumb
                                style={{
                                    padding: '17px 0 8px',
                                    width: '100%',
                                    backgroundColor: '#fff',
                                    fontSize: '14px',
                                }}
                            >
                                {breadcrumbItem.map((item, index) => (
                                    <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
                                ))}
                            </Breadcrumb>
                        )}
                        <div className="right-top-label"></div>
                        <Content
                            style={{
                                margin: 0,
                                marginTop: 0,
                            }}
                        >
                            {children}
                        </Content>
                    </Layout>
                </Layout>
                {this.props.location.pathname !== '/index' && (
                    //  <Footer style={{ textAlign: "center" }}></Footer>
                    <Footer style={{ textAlign: 'center', backgroundColor: '#fff' }}></Footer>
                )}
            </Layout>
        );
    }
}
